import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useStyles from "./styles";
import { validarSenha } from "../../utils/validateFields";
import "./checkAnimation.css";
import { useNotification } from "../../componentes/notificationProvider";

interface Params extends Record<string, string | undefined> {
  id?: string;
  token?: string;
}

export default function RedefinirSenha() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [textFeedback, setTextFeedback] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [senha, setSenha] = useState<string>("");
  const [confirmSenha, setConfirmSenha] = useState<string>("");
  const [Null, setNull] = useState<boolean>(false);
  const [senhaValid, setSenhaValid] = useState<boolean>(false);
  const [feedback, setFeedback] = useState<boolean>(false);

  const url = `${window?.config?.REACT_APP_BASE_URL || ""}`;
  const { id, token } = useParams<Params>();

  const notify = useNotification();
  const navigate = useNavigate();
  useEffect(() => {
    setSenhaValid(validarSenha(senha));
  }, [senha]);

  // useEffect(() => {
  //   async function permissionValidate() {
  //     try {
  //       await axios.get(`${url}/authenticationTokenUpdatePassword`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //     } catch (error: any) {
  //       if (error?.response?.status === 401) {
  //         setTextFeedback(
  //           "Infelizmente o link expirou, solicite outro link no site da MW e tente novamente!"
  //         );
  //         setFeedback(true);
  //       } else {
  //         setAlertServiceOpen(true);
  //       }
  //     }
  //   }
  //   permissionValidate();
  // }, [token, url]);

  const handleUpdate = async () => {
    if (!senha || !confirmSenha || confirmSenha !== senha || !senhaValid) {
      setNull(true);
      return;
    }

    try {
      await axios.put(
        `${url}/public/usuario/resetPassword/update`,
        {
          password: senha,
          usuarioId: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTextFeedback("Senha atualizada com sucesso!");
      setFeedback(true);
    } catch (error: any) {
      notify(error?.status || 500, undefined, "error", error);

      //setAlertServiceOpen(true);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleUpdate();
    }
  };

  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        justifyContent={"center"}
        alignItems={"center"}
        sx={styles.stackPage}
      >
        <Paper sx={styles.paperForm}>
          <Stack justifyContent={"center"} alignItems={"center"}>
            {!feedback && (
              <>
                <Typography sx={styles.title}>Redefinição de senha</Typography>

                <Typography sx={styles.subtitle}>
                  Digite a nova senha e confirme em seguida.
                </Typography>
              </>
            )}

            {/* {loading && (
              <Box sx={styles.loadingLogo}>
                <CircularProgress
                  size={100}
                  sx={styles.circularProgress}
                  thickness={2.5}
                />
              </Box>
            )} */}
          </Stack>

          {!feedback && (
            <>
              <TextField
                autoComplete="off"
                value={senha}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setSenha(e.target.value)
                }
                error={senha != "" && !senhaValid}
                type={showPassword ? "text" : "password"}
                helperText={
                  senha != "" && !senhaValid
                    ? " A senha precisa ter no mínimo 6 digítos, uma letra e um número."
                    : ""
                }
                label="Senha"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((show) => !show)}
                        onMouseDown={(event) => {
                          event.preventDefault();
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="filled"
              />
              <TextField
                autoComplete="off"
                value={confirmSenha}
                onKeyDown={handleKeyDown}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setConfirmSenha(e.target.value)
                }
                error={confirmSenha != "" && senha !== confirmSenha}
                type={showPassword ? "text" : "password"}
                helperText={
                  confirmSenha != "" && senha !== confirmSenha
                    ? "As senhas não conferem!"
                    : ""
                }
                label="Confirmar senha"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((show) => !show)}
                        onMouseDown={(event) => {
                          event.preventDefault();
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="filled"
              />

              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={styles.button}
              >
                Redefinir a Senha
              </Button>
            </>
          )}
          {feedback && (
            <>
              <Stack justifyContent={"center"} alignItems={"center"} gap={3}>
                <Box className="success-animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </Box>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <Typography sx={styles.title}>Senha alterada!</Typography>
                  <Typography sx={styles.subtitle}>
                    Entre agora e aproveite tudo o que o sistema oferece!
                  </Typography>
                </Stack>

                <Button
                  onClick={() => navigate("/login")}
                  fullWidth
                  variant="contained"
                >
                  Fazer Login
                </Button>
              </Stack>
            </>
          )}
          <Divider sx={{ width: "100%", mt: 1 }} />
          <Typography sx={styles.linkText}>
            Precisa de ajuda? <br />
            <Link href="/login" sx={{ textDecoration: "none" }}>
              Entre em contato com nossa equipe
            </Link>
          </Typography>
        </Paper>
      </Stack>
    </>
  );
}
